{
  "R": [255, 255, 255],
  "G": [127, 196, 254],
  "B": [0, 0, 0],
  "A": [0, 64, 128],
  "I": [0, 128, 255]
}
